module.exports = __webpack_public_path__ + "static/media/IconPdf.a0553da3.svg";